import { ToolViewerActivationMessage, RemoveToolFromBlueprintMessage, AddToolFromBlueprintMessage } from "flavr-common";
import { busService } from "../../bus";
const bluePrintConnection = busService.connection("ScriptToolViewerBelt");
export class ScriptToolViewerBelt {
    static addBluePrint(name, description, fileId) {
        bluePrintConnection.send(new AddToolFromBlueprintMessage(name, description, fileId));
    }
    static removeBluePrint(name, fileId) {
        bluePrintConnection.send(new RemoveToolFromBlueprintMessage(name, fileId));
    }
    static setActive(active) {
        bluePrintConnection.send(new ToolViewerActivationMessage(active));
    }
}
